import React, { memo } from 'react';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { handleRedirectToContactDetails } from 'containers/Contacts/utils';

interface Props {
  avatar?: string;
  fullName?: string;
  userType?: string;
  id?: string;
}

const CustomerField = memo(({ avatar, fullName, userType, id }: Props) => (
  <Link to={() => handleRedirectToContactDetails(userType, id)}>
    <div className="flex items-center">
      <Avatar size={48} src={avatar} alt="" icon={<UserOutlined />} />
      <div className="fw-700 text-14 lh-24 text-black-base ml-8">
        {fullName}
      </div>
    </div>
  </Link>
));

export default CustomerField;
